import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon20 } from 'builder/components/Icon'
import Button from 'builder/components/Button'

export const Close = styled.div`
  position: absolute;
  width: 28px;
  height: 28px;
  top: 28px;
  right: 28px;
  border-radius: 32px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Colors.Neutral50};
  cursor: pointer;
  transition: color 0.1s;
  background-color: ${Colors.Neutral10};
  z-index: 999;

  &:hover {
    color: ${Colors.Blue50};
  }

  ${Media.Phone`
    top: 20px;
    right: 20px;
    padding: 2px;
  `};
`

export const Content = styled.div`
  display: flex;
  border-radius: 16px;
  background-color: ${Colors.White};
  position: relative;

  ${Media.Tablet`
    flex-direction: column;
    max-width: 604px;
    width: 100%;
  `};
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  max-width: 447px;
  width: 100%;

  ${Media.Tablet`
    order: 2;
    max-width: unset;
  `};

  ${Media.Phone`
    padding: 24px;
  `};
`

export const Title = styled.span`
  color: ${Colors.Neutral90};
  ${FontWeights.DemiBold};
  ${Typography.M};
`

export const Subtitle = styled.span`
  color: ${Colors.Neutral50};
  ${Typography.Caption};
  margin-top: 20px;

  ${Media.Phone`
    margin-top: 8px;
  `};
`

export const ItemsTitle = styled.span`
  color: ${Colors.Neutral80};
  ${FontWeights.DemiBold};
  ${Typography.Caps};
  text-transform: uppercase;
  margin-top: 24px;
`

export const Items = styled.div`
  background-color: ${Colors.Neutral5};
  border-radius: 4px;
  gap: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  margin-top: 12px;

  ${Media.Tablet`
    flex-direction: row;
    flex-wrap: wrap;
  `};

  ${Media.Phone`
    flex-direction: column;
  `};
`

export const Item = styled.div`
  gap: 4px;
  display: flex;
  align-items: center;

  ${Media.Tablet`
    flex: 1 0 34%;
  `};
`

export const Check = styled(Icon20.Tick)`
  color: ${Colors.Blue50};
`

export const ItemText = styled.span`
  color: ${Colors.Neutral80};
  ${Typography.Caption};
`

export const GetButton = styled(Button)`
  width: fit-content;
  margin-top: auto;

  ${Media.Tablet`
    margin-left: auto;
    margin-top: 32px;
  `};

  ${Media.Phone`
    width: 100%;
    margin-top: 20px;
  `};
`

export const ImagesTitle = styled.span`
  color: ${Colors.Neutral90};
  ${FontWeights.Medium};
  ${Typography.Subhead};

  ${Media.Tablet`
    display: none;
  `};
`

export const ImagesContainer = styled.div`
  background-color: ${Colors.Blue10};
  padding: 58px 62px 68px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  border-radius: 16px;

  ${Media.Tablet`
    padding: 26px 0 14px;
  `};
`

export const CritiqueImg = styled.img`
  width: 412px;
  height: 372px;

  ${Media.Phone`
    width: 219px;
    height: 182px;
  `};
`
